import { render, staticRenderFns } from "./TransactionDetail.vue?vue&type=template&id=61b47854"
import script from "./TransactionDetail.vue?vue&type=script&lang=js"
export * from "./TransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61b47854')) {
      api.createRecord('61b47854', component.options)
    } else {
      api.reload('61b47854', component.options)
    }
    module.hot.accept("./TransactionDetail.vue?vue&type=template&id=61b47854", function () {
      api.rerender('61b47854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/widgets/TransactionDetail.vue"
export default component.exports